import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/services", label: "Services" },
  { to: "/tax-services", label: "Tax Services" },
  { to: "/pricing", label: "Pricing" },
  { to: "/industries", label: "Industries" },
  { to: "/our-story", label: "Our Story" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Get Started" },
];

export default function Footer() {
  return (
    <footer className="bg-pine-950 text-cream" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:py-20">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo light />
            <p className="mt-6 max-w-sm font-serif text-2xl italic leading-snug text-cream/90">
              Accurate books. Fewer surprises. Greater confidence.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Explore</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.slice(1)}`}
                    className="text-sm text-cream/70 transition-colors duration-200 hover:text-gold"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">Contact</p>
            <ul className="mt-5 space-y-4 text-sm text-cream/80">
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gold" />
                <a href="mailto:Arnold.Bookkeeping@outlook.com" data-testid="footer-email-link" className="hover:text-gold transition-colors duration-200">
                  Arnold.Bookkeeping@outlook.com
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-gold" />
                <a href="tel:7175541224" data-testid="footer-phone-link" className="hover:text-gold transition-colors duration-200">
                  717.554.1224
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-gold" />
                <span>Pennsylvania, USA</span>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-16 flex flex-col gap-3 border-t border-cream/10 pt-8 text-xs text-cream/50 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 Arnold Bookkeeping, LLC. All rights reserved.</p>
          <p className="font-mono tracking-wide">Bookkeeping &amp; tax services for small businesses</p>
        </div>
      </div>
    </footer>
  );
}
